import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { initializeFirestore, serverTimestamp } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions"
import { detectIosStandalone } from '@/utils/detectIosStandalone';
import { trace } from '@/utils/authTrace';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

const db = process.env.VUE_APP_FIREBASE_DATABASE;

const app = initializeApp(firebaseConfig);

const projectAuth = getAuth(app);
// iOS standalone (PWA) WebChannel streaming is known-broken in WKWebView:
// on SDK v9.23, experimentalAutoDetectLongPolling's probe passes on the
// FIRST stream, then every subsequent stream stalls ~30s before failing.
// Auto-detect can't self-correct from that (it only probes once), so force
// long-polling — but ONLY in the one environment where streaming is known
// broken; everywhere else keeps auto-detect (falls back to long-polling on
// genuine streaming failure, otherwise keeps the low-latency channel).
const iosStandalone = detectIosStandalone();
trace('firestore-transport', { iosStandalone, forced: iosStandalone });
const projectFirestore = initializeFirestore(
  app,
  iosStandalone ? { experimentalForceLongPolling: true } : { experimentalAutoDetectLongPolling: true },
  db
);
const timestamp = serverTimestamp;
const projectStorage = getStorage(app);
const provider = new GoogleAuthProvider();
const functions = getFunctions(app, 'australia-southeast1');

export { projectAuth, projectFirestore, projectStorage, timestamp, provider, functions };